import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTestError  {
    _originalTypeClassName = "zERP.BO.InvoiceTestError";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTestError.translate = translateService;
}
this.Description = null;
this.InvoiceTestErrorKey = null;
this._key = this.InvoiceTestErrorKey = 0; 
}

static translate: TranslateService;
_key: any;
Description:any;
private _InvoiceTestErrorKey:any;
get InvoiceTestErrorKey(): any {
    return this._InvoiceTestErrorKey;
  }
set InvoiceTestErrorKey(value: any) {
    this._InvoiceTestErrorKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceTestErrorKey == null || $this.InvoiceTestErrorKey == 0;
            }


}